import type { State } from '../reducer';
import type { AnalyticsDataState } from './reducer';

export const get = (state: State): AnalyticsDataState => state.analyticsData;
